export const getMemberName = (memberId, membersList) => {
    if (membersList && membersList.length > 0 && membersList.some(item => item.id === memberId)) {
        return membersList.find(item => item.id === memberId).name;
    }
};
export const getEventName = (eventURL, eventsList) => {
    if (eventsList && eventsList.length > 0 && eventsList.some(item => item.eventUrl === eventURL)) {
        return eventsList.find(item => item.eventUrl === eventURL).name;
    }
};
export const replaceMemberEvent = (announcement, membersList, eventsList) => {
    if (announcement) {
        let {message} = announcement;
        if (announcement.message && announcement.message.toLowerCase().indexOf('profile') > -1 && announcement.memberId !== null) {
            message = message.replace(
                /profile/gi,
                `<a href="#/memberProfile?memberId=${announcement.memberId}">${getMemberName(
                    announcement.memberId,
                    membersList
                )}</a>`
            );
        }
        if (announcement.message && announcement.message.toLowerCase().indexOf('event') > -1 && announcement.eventUrl !== '') {
            message = message.replace(
                /event/gi,
                `<a target="_blank" href="${announcement.eventUrl}">${getEventName(
                    announcement.eventUrl,
                    eventsList
                )}</a>`
            );
        }
        return message;
    }
    return '';
};
